<template>
  <div class="ornaOpen">
    <div class="oran-warp">
      <div class="oran-top">
        <div class="orantop-left">幸运饰品</div>
        <div class="orantop-right" @click="goHistory">获得饰品历史</div>
      </div>
    </div>
    <div class="lucky-open">
      <div class="oran-sel">
        <div class="open">
          <div class="open-hint">
            <div class="open-hint1">选择你期望的幸运值</div>
            <div class="open-hint2">
              <span>玩法介绍和特别说明</span>
              <i class="el-icon-question"></i>
            </div>
            <div class="open-hint3" @click="isPlayAudio=!isPlayAudio">
              <img v-show="isPlayAudio" src="@/assets/img/sheng.png" />
              <img v-show="!isPlayAudio" src="@/assets/img/sheng_no.png" />
            </div>
          </div>

          <div class="open-box">
            <div class="box-one"><img src="@/assets/img/left.png" /></div>
            <!--
            <div class="box-two">
              <div class="t">随机物品</div>
              <img src="@/assets/img/box3.png" />
            </div>
            <div class="box-three">{{ value3 }}%</div>
            -->
            <div class="box-four">
              <div class="four-top">幸运饰品</div>
              <div class="four-bot">
                <div class="img">
                  <img :src="obj.imageUrl" />
                </div>
                <div class="name">{{ obj.itemName }}</div>
                <img class="por" src="@/assets/img/top.png" />
              </div>
            </div>
            <div class="box-five"><img src="@/assets/img/right.png" /></div>
          </div>
          <!--
          <div class="open-text">
            你会随机获得一件饰品，并有 {{ value3 }}%
            的机会额外获得一件珍稀的饰品
          </div>
          -->

          <div class="open-pro">
            <div class="pro-img">
              <img src="@/assets/img/yuan1.png" />
              <div class="peo-num peo-num1">
                <h5 class="peo-num1-h5">{{ value3 }}%</h5>
                <h6>成功</h6>
              </div>
            </div>
            <div class="pro-con">
              <el-slider v-model="value3" :show-tooltip="false" :min="1" :max="100" @change="changeNum"></el-slider>
            </div>
            <div class="pro-img">
              <img src="@/assets/img/yuan2.png" />
              <div class="peo-num peo-num2">
                <h5>{{ 100 - value3 }}%</h5>
                <h6>失败</h6>
              </div>
            </div>
          </div>

          <div class="open-btn">
            <el-button :disabled="disabled" class="open-btnwarp" :style="{ 'background-color': loading ? '#949493' : '#ffbb00' }" @click="upgrade">
              <i v-if="loading" class="el-icon-loading"></i>
              <span>花费</span>
              <img src="@/assets/images/money.png" class="money-img" />
              <span>{{ ((price * value3) / 100).toFixed(2) }} 试试运气</span>
            </el-button>
          </div>
          <div class="open-anim-wrap">
            <div class="open-anim">
              <div class="open-line" ref="openLine"></div>
              <div class="open-anim-warp">
                <ul :class="[openAnimState&&isThree ? 'ul2' :'',openAnimState&&!isThree ? 'ul1' :'']" ref="ul">
                  <li v-for="(item, index) in openAnimList" :key="index" :style="{
                      backgroundImage: 'url(' + item.back + ')',
                    }" :class="item.name != '赠品' ? 'li1' : ''" class="flex-0">
                    <img :src="item.imageUrl" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--开出来的饰品-->
    <div class="csgo-mask flex flex-jc flex-ac" v-if="winState" style="z-index: 1001;">
      <div class="win-box">
        <div class="win">
          <div class="win-top">
            <img src="@/assets/img/win1.png" />
          </div>
          <div class="win-con">
            <ul>
              <li v-for="(item, index) in list4" :key="index">
                <div class="win-warp">
                  <div class="win-img" :style="{
                    backgroundImage: 'url(' + item.back + ')',
                  }">
                    <img :src="item.img" />
                  </div>
                  <span>{{ item.price }}</span>
                  <div class="win-text">{{ item.name }}</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="win-bot">
            <div class="win-span1" v-if="!winFalse" @click="winX">
              <span>确定</span>
            </div>
            <div class="win-span2" v-if="winFalse" @click="winget">放入背包</div>
          </div>
          <div class="win-x" @click="winX">
            <i class="el-icon-circle-close"></i>
          </div>
          <div class="win-back">
            <img src="@/assets/img/win3.png" />
          </div>
        </div>
      </div>
    </div>
    <audio controls ref="notify4" class="audio" style="display: none;">
      <source src="@/assets/audio/open_box6s.mp3" />
    </audio>
    <div class="commonBg"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      id: '',
      isPlayAudio: true,
      openAnimState: false,
      openAnimList: [],
      disabled: false,
      winFalse: true,
      loading: false,
      search: "",
      value3: 25,
      list: [
        { name: 1 },
        { name: 12 },
        { name: 13 },
        { name: 14 },
        { name: 15 },
        { name: 16 },
        { name: 17 },
        { name: 18 },
        { name: 19 },
        { name: 111 },
        { name: 123 },
        { name: 143 },
      ],
      list4: [],
      winState: false,
      price: "",
      obj: "",
      noWin: {
        name: "赠品",
        price: "0.01",
        img: require("@/assets/images/moneyback.png"),
        imageUrl: require("@/assets/images/moneyback.png"),
        class: "img-class",
        back: require("@/assets/img/box-skins-white.png"),
      },
      valueState: false,
    };
  },
  watch: {},
  created() {
    this.id = this.$route.query.id;
    this.getData()

    this.loading = false;
    this.disabled = false;
  },
  mounted() { },
  methods: {
    playAlarm1() {
      this.$refs.notify4.play();
    },
    playAlarm2() {
      this.$refs.notify4.pause();
    },
    getData() {
      this.$doGet('/api/hall.LuckySkin/info', {
        skin_id: this.id,
      }).then((res) => {
        this.obj = res.data
        // res.data.imageUrl = 'http://47.94.52.130:9526/storage/csgo/skins/UDkwIHwgRmFjaWxpdHkgTmVnYXRpdmUgKEZpZWxkLVRlc3RlZCk=.png'
        res.data.img = res.data.imageUrl
        this.price = this.obj.price
        this.obj.back = require("@/assets/img/box-skins-golden.png");
        this.disruptArr();
      }).catch(() => { })
    },
    goHistory() {
      this.$router.push({
        path: '/lucky/history'
      })
    },
    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
    //拖动滑动条 鼠标松开
    changeNum() {
      this.disruptArr();
    },
    //打乱滚动数据
    disruptArr() {
      if (this.loading) {
        return;
      }
      this.openAnimList = [];
      let numImg = parseInt((50 * this.value3) / 100);
      if (numImg < 13) {
        numImg = 13;
      }
      for (let i = 0; i < 50; i++) {
        if (i < numImg) {
          this.openAnimList.push(this.obj);
        } else {
          this.openAnimList.push(this.noWin);
        }
      }
      this.openAnimList = this.getRandomArr(this.openAnimList, 50);
      this.openAnimList[0] = this.obj;
    },
    goOrnament(idnex) {
      this.$router.push({
        path: `/Ornament`,
      });
    },
    //点击兑换
    winexchange() {
      let param = {
        player_skins_ids: [this.list4[0].player_skin_id],
      };
      this.$doPost("/api/member.SkinBackpack/exchangeToMoney", param).then((res) => {
        this.openAnimState = false;
        this.winState = false;
        // this.$store.commit("getMoney", res.data.total_amount);
        this.$store.commit("getAboutMon", res.data)
        this.$message({
          showClose: true,
          message: res.msg,
          type: "success",
        });
      }).catch(() => { })
    },
    //放入背包
    winget() {
      this.winState = false;
      //改变动画
      this.openAnimState = false;
    },
    //点击升级
    upgrade(event) {
      this.isThree = window.innerWidth < 540
      if (!this.$store.state.loginState) {
        this.$store.commit("getLogin", true);
        return;
      }
      this.winState = false;
      this.loading = true;
      this.disabled = true;
      let param = {
        skin_id: this.id,
        probability: this.value3,
      };
      // 这个是模拟数据
      // let res = {
      //   code: 200,
      //   msg: "恭喜中奖",
      //   data: {
      //     appId: 730,
      //     create_time: "2025-12-11 15:55:01",
      //     img: "http://47.94.52.130:9526/storage/csgo/skins/U2VhbGVkIEdyYWZmaXRpIHwgRGVhdGggU2VudGVuY2UgKEZyb2cgR3JlZW4p.png",
      //     itemId: "193349995",
      //     masonry: "15.98",
      //     name: "封装的涂鸦 | 死刑 (暗绿)",
      //     open_number: 22,
      //     open_number_md: "b6d767d2f8ed5d21a44b0e5886680cb9",
      //     order_num: "L20251215550196714044",
      //     player_id: 208,
      //     player_skin_id: 9614,
      //     price: "0.02",
      //     priceInfo: null,
      //     probability: 79,
      //     total_amount: "814863.59",
      //     type_id: "",
      //     way: 3,
      //   }
      // }
      this.$doPost("/api/hall.LuckySkin/upgradeSkin", param).then((res) => {
        let data = res
        if (this.isPlayAudio) {
          this.playAlarm1()
        }
        this.openAnimState = true
        this.$store.commit("getAboutMon", data.data)
        this.list4 = [];
        if (data.msg == "恭喜中奖") {
          data.data.imageUrl = data.data.img
          data.data.back = require("@/assets/img/box-skins-golden.png");
          this.openAnimList[40] = data.data
          this.list4.push(data.data);
        } else {
          // this.$store.commit("getMoney", data.data.total_amount.toFixed(2));
          this.openAnimList[40] = this.noWin
          this.list4.push(this.noWin)
        }
        this.$forceUpdate()
        setTimeout(() => {
          this.loading = false
          this.disabled = false
          this.openAnimState = false
          this.winFalse = true
          this.winState = true
          if (this.isPlayAudio) {
            this.playAlarm2()
          }
        }, 7100)
      }).catch(() => {
        this.loading = false;
        this.disabled = false;
      })
    },

    winX() {
      //改变动画
      this.openAnimState = false;
      this.winState = false;
    },
  },
};
</script>

<style lang="less" scoped>
.ornaOpen {
  max-width: 1500px;
  margin: auto;
  background: rgba(26, 28, 32, 0.9);
  .lucky-open {
    padding: 16px;
  }
  //动画
  .open-anim-wrap {
    margin-top: 30px;
    // padding: 10px;
    // background-color: #383856;
    overflow: hidden;
    .open-anim {
      position: relative;
      overflow: hidden;
      .open-line {
        position: absolute;
        height: 100%;
        width: 3px;
        background-color: #ffbb00;
        top: 0;
        left: calc(50% - 1.5px);
        z-index: 66;
        &::before {
          content: '';
          background-image: url('~@/assets/img/pointer.png');
          width: 38px;
          height: 19px;
          position: absolute;
          top: -1px;
          left: 2px;
          transform: translateX(-50%) rotate(180deg);
          background-size: 100% 100%;
        }
        &::after {
          content: '';
          background-image: url('~@/assets/img/pointer.png');
          width: 38px;
          height: 19px;
          position: absolute;
          bottom: -1px;
          left: -18px;
          // transform: translateX(-50%) rotate(180deg);
          background-size: 100% 100%;
        }
      }
      .open-anim-warp {
        overflow: hidden;
        position: relative;
      }
      ul {
        width: 100%;
        position: relative;
        left: 0;
        display: flex;
        li {
          background-image: url('~@/assets/img/box-skins-blue.jpg');
          background-size: 100% 100%;
          box-sizing: border-box;
          height: 150px;
          width: 20%;
          overflow: hidden;
          // margin-right: 5px;
          border: 2px solid #92a9b6;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            // margin-left: 10px;
            // margin-top: 10px;
            width: auto;
            max-width: calc(100% - 10px);
            height: 80%;
          }
        }
        .li1 {
          border: 2px solid #c9a167;
        }
      }
      .ul1 {
        animation: run11 7s;
        animation-timing-function: ease; //动画慢 快 慢
        animation-iteration-count: 1; //播放几次动画
        animation-delay: 0s; //动画运行前等待时间
        animation-fill-mode: forwards; //动画结束 是否保持
        @keyframes run11 {
          0% {
            left: 0;
          }
          100% {
            left: -760%;
          }
        }
      }
      .ul2 {
        animation: run12 7s;
        animation-timing-function: ease; //动画慢 快 慢
        animation-iteration-count: 1; //播放几次动画
        animation-delay: 0s; //动画运行前等待时间
        animation-fill-mode: forwards; //动画结束 是否保持
        @keyframes run12 {
          0% {
            left: 0;
          }
          100% {
            left: -1300%;
          }
        }
      }
    }
  }

  .oran-warp {
    padding: 16px;
    overflow: hidden;
  }
  .oran-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    .orantop-left {
      color: #c3c3e2;
      font-size: 20px;
    }
    .orantop-right {
      padding: 12px 22px;
      background-color: #333542;
      border-radius: 5px;
      color: #848492;
      font-size: 15px;
      font-weight: 600;
    }
    .orantop-right:hover {
      cursor: pointer;
      background-color: #3a3f50;
    }
  }

  .open {
    margin-bottom: 100px; //后修改
    margin-top: 16px;
    background-color: #2b2c37;
    border-radius: 5px;
    padding: 16px;
    .open-hint {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .open-hint1 {
        font-size: 20px;
        color: #c3c3e2;
      }
      .open-hint2 {
        display: flex;
        align-items: center;
        span {
          margin-right: 5px;
          font-size: 14px;
          color: #848492;
        }
        i {
          font-size: 14px;
          color: #848492;
        }
        i:hover {
          cursor: pointer;
        }
      }
      .open-hint3 {
        img {
          width: 40px;
          height: 40px;
          cursor: pointer;
        }
      }
    }

    .open-box {
      margin-top: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 200px;
      .box-one {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 70%;
        }
      }

      .box-two {
        height: 100%;
        position: relative;
        width: 220px;
        margin-top: -50px;
        img {
          height: 130%;
          width: 100%;
        }
        .t {
          position: absolute;
          top: 25px;
          width: 100%;
          text-align: center;
          color: #c3c3e2;
        }
      }

      .box-three {
        min-width: 50px;
        text-align: center;
        height: 100%;
        color: #c3c3e2;
        line-height: 200px;
        padding: 0 20px;
        font-weight: 600;
        font-size: 20px;
      }

      .box-four {
        height: 100%;
        // margin-top: -50px;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        width: 220px;
        text-align: center;
        .four-top {
          color: #e9b10e;
        }

        .four-bot {
          position: relative;
          width: 100%;
          // padding: 0 20px;
          margin-top: 25px;
          .img {
            background-image: url('~@/assets/img/box-skins-blue.jpg');
            background-size: 100% 100%;
            border-bottom: 2px solid #e9b10e;
            height: 130px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 80%;
            }
          }
          .name {
            padding: 8px;
            font-size: 14px;
            color: #c3c3e2;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            background-color: #24252f;
          }

          .por {
            position: absolute;
            left: 0;
            top: -25%;
            width: 100%;
          }
        }
      }

      .box-five {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 70%;
        }
      }
    }

    .open-text {
      margin-top: 30px;
      text-align: center;
      color: #c3c3e2;
      font-size: 16px;
    }

    .open-pro {
      margin-top: 50px;
      width: 50%;
      margin-left: 25%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .pro-img {
        position: relative;
        img {
          width: 200px;
          height: 200px;
        }
        .peo-num {
          width: 100px;
          height: 100px;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -50px;
          margin-top: -50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .peo-num1 {
          h5 {
            color: #50e3c2;
            font-size: 25px;
            font-weight: 400;
          }
          h6 {
            color: #50e3c2;
            font-size: 14px;
            font-weight: 400;
          }
        }
        .peo-num2 {
          h5 {
            color: #fd492c;
            font-size: 25px;
            font-weight: 400;
          }
          h6 {
            color: #fd492c;
            font-size: 14px;
            font-weight: 400;
          }
        }
      }
      .pro-con {
        width: 60%;
      }
    }

    .open-btn {
      display: flex;
      justify-content: center;
      .open-btnwarp {
        background-color: #e9b10e;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px 70px;
        border-radius: 5px;

        span {
          font-size: 16px;
          font-weight: 600;
        }
        img {
          width: 25px;
          height: 25px;
          margin: 0 5px;
          position: relative;
          top: 5px;
        }
      }
      .open-btnwarp:hover {
        cursor: pointer;
        background-color: #ffbb00;
      }
      .open-btnwarp:active {
        cursor: pointer;
        background-color: #949493;
      }
    }
  }

  .win-box {
    .win {
      width: 450px;
      padding: 20px;
      background-color: rgba(0, 0, 0, 0.4);
      position: relative;
      border-radius: 10px;
      .win-back {
        width: 100%;
        height: auto;
        position: absolute;
        top: 15%;
        left: 0;
        z-index: -10;
        animation: move 5s linear infinite;

        img {
          width: 100%;
          height: auto;
        }
      }
      @keyframes move {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      .win-top {
        width: 100%;
        display: flex;
        justify-content: center;
        img {
          width: 80%;
          height: auto;
        }
      }
      .win-x {
        position: absolute;
        top: 0px;
        right: 0px;
        color: #e9b10e;
        text-align: center;
        padding: 10px;
        font-size: 30px;
      }
      .win-x:hover {
        cursor: pointer;
      }
      .win-bot {
        margin-top: 10px;
        .win-span1 {
          width: 80%;
          margin-left: 10%;
          padding: 10px 0;
          background-color: #e9b10e;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          span {
            color: #000;
            font-weight: 600;
            font-size: 15px;
          }
          img {
            margin-left: 20px;
            margin-right: 5px;
            width: auto;
            height: 15px;
          }
        }
        .win-span1:hover {
          cursor: pointer;
        }
        .win-span2 {
          margin-top: 10px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #fff;
        }
        .win-span2:hover {
          cursor: pointer;
        }
      }

      .win-con {
        display: flex;
        justify-content: center;
        ul {
          width: 60%;
          display: flex;
          justify-content: center;
          li {
            width: 80%;
            border-radius: 5px;
            overflow: hidden;
            .win-warp {
              width: 100%;
              background-color: #e2c873;
              position: relative;
              .win-img {
                padding: 10px;
                //background-image: url("~@/assets/img/box-skins-golden.png");
                background-size: 100% 100%;
                img {
                  width: 100%;
                  height: auto;
                }
              }
              .img-class {
                display: flex;
                justify-content: center;
                padding: 30px 40px;
                img {
                  height: 100px;
                  width: auto;
                }
              }
              span {
                position: absolute;
                right: 1px;
                top: 1px;
                background-color: rgba(0, 0, 0, 0.2);
                color: #fff;
                font-size: 12px;
                padding: 2px 4px;
                border-radius: 20px;
                min-width: 20px;
                text-align: center;
              }
              .win-text {
                width: 100%;
                padding: 10px 0;
                text-align: center;
                color: #e9b10e;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
  /deep/ .el-button {
    border: none;
  }
  /deep/ .el-slider__button {
    border: 2px solid #a0eccc;
  }
  /deep/.el-slider__bar {
    background-color: #a0eccc;
  }
  /deep/ .el-slider__runway {
    background-color: #e4b3a5;
  }
}
</style>
